import React from 'react'

interface PlaybackControlsProps {
  isPlaying: boolean
  onPlay: () => void
  onReset: () => void
}

export function PlaybackControls({ isPlaying, onPlay, onReset }: PlaybackControlsProps) {
  return (
    <div className="flex gap-2">
      <button
        onClick={onPlay}
        disabled={isPlaying}
        className={`flex-1 flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium
          rounded-lg transition-all cursor-pointer
          ${isPlaying
            ? 'bg-gray-800 text-white/70 cursor-not-allowed animate-pulse'
            : 'bg-gray-900 text-white hover:bg-gray-800 active:scale-[0.98]'
          }`}
      >
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M8 5v14l11-7z" />
        </svg>
        {isPlaying ? 'Playing...' : 'Play'}
      </button>
      <button
        onClick={onReset}
        className="px-3 py-2.5 text-sm font-medium text-gray-600 bg-gray-100 rounded-lg
          hover:bg-gray-200 hover:text-gray-800 transition-all cursor-pointer active:scale-[0.98]"
        title="Reset"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
      </button>
    </div>
  )
}
